<template>
  <li class="ui-form-item">
    <div
      v-if="$slots.label || label"
      class="ui-form-item__label"
      :class="[
        `min-w-${minWidth}`,
        {
          'ui-form-item__label--align-left': labelAlign === 'left',
          'ui-form-item__label--tooltip-bottom-left': tooltip && tooltipPosition === 'bottom-left',
        },
      ]"
    >
      <!-- label 슬롯 사용 시 우선, 미사용 시 기존 prop 렌더링 (호환성 유지) -->
      <slot name="label">
        <span v-html="label"></span>
      </slot>
      <!-- 툴팁 아이콘. tooltip 슬롯이 있으면 제목(strong)+본문(p)처럼 구성할 수 있다 -->
      <UiTooltip v-if="tooltip || $slots.tooltip" :position="tooltipPosition">
        <template #trigger>
          <span class="ui-form-item__tooltip-icon" @click.stop>?</span>
        </template>
        <div class="ui-form-item__tooltip-body">
          <slot name="tooltip">
            <p>{{ tooltip }}</p>
          </slot>
        </div>
      </UiTooltip>
    </div>
    <div class="ui-form-item__content">
      <slot></slot>
    </div>
  </li>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: '',
  },
  minWidth: {
    type: String,
    default: '80px'
  },
  tooltip: {
    type: String,
    default: ''
  },
  tooltipPosition: {
    type: String,
    default: 'bottom',
    validator: v => ['top', 'right', 'bottom', 'left', 'bottom-left', 'top-left', 'top-right'].includes(v),
  },
  labelAlign: {
    type: String,
    default: 'right',
    validator: (v) => v === 'left' || v === 'right',
  }
});
</script>

<style lang="scss" scoped>
.ui-form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  &__label {
    flex-shrink: 0;
    font-size: $font-size-lg;
    font-weight: 500;
    margin-right: 15px;
    min-width: 130px;
    flex: none;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;

    &--align-left {
      text-align: left;
      justify-content: flex-start;
    }

    &--tooltip-bottom-left {
      :deep(.ui-tooltip),
      :deep(.ui-tooltip-content) {
        text-align: left;
      }

      .ui-form-item__tooltip-body p {
        text-align: left;
      }
    }
  }

  &__tooltip-body {
    p {
      margin: 0;
    }
  }

  &__content {
    flex: 1;
    min-width: 0; /* 내용 넘침 방지 */
  }

  &__tooltip-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #6D7882;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    flex-shrink: 0;
    position: relative;
    top: -2px;
  }

  &__actions {
    display: flex;
    gap: 8px;
    margin-left: 16px;
  }
}
</style>
